import e from "deepmerge";
//#region src/utils/createBaseApi.ts
function t(e, t) {
	let n = {
		...e,
		...t
	};
	return Object.fromEntries(Object.entries(n).filter(([, e]) => e !== null));
}
function n(n, r) {
	let i = e(n, r, { customMerge: (e) => {
		if (e === "headers") return t;
	} });
	return {
		...i,
		body: r.body instanceof FormData ? r.body : i.body
	};
}
var r = (t = "", r = {}, i) => {
	let a = e({
		credentials: "include",
		headers: {
			Accept: "application/json",
			"Content-Type": "application/json"
		}
	}, r);
	return async (e, r = {}, o) => {
		let s = await fetch(`${t}${e}`, n(a, r));
		return s.ok ? s.status === 204 ? {
			data: null,
			error: !1,
			res: s
		} : {
			data: await (o?.responseTransform?.(s) ?? s.json().catch(() => void 0)),
			error: !1,
			res: s
		} : (i?.(s), {
			data: null,
			error: !0,
			res: s
		});
	};
}, i = (e) => {
	let t = (t) => (n, r) => t(e.route(n), {
		method: e.method ?? "GET",
		body: e.method === "POST" && e.body ? e.body(n) : null,
		...e.requestOptions
	}, e.config);
	return t.mocking = e.mocking && {
		...e.mocking,
		status: e.mocking?.status ?? 200
	}, t.method = e.method ?? "GET", t.paramQueryKeyTransform = e.paramQueryKeyTransform, t.queryKey = [...e.persist ? ["persist"] : [], ...e.queryKey], t.demoModeHandler = e.demoModeHandler, t;
}, a = (e) => {
	let t = (t) => (n, r) => t(e.route(n), {
		...e.requestOptions,
		method: e.method,
		body: e.body ? e.body(n) : null,
		headers: {
			...e.requestOptions?.headers,
			...e.headers?.(n)
		}
	}, e.config);
	return t.invalidateQueries = e.invalidateQueries, t.method = e.method, t.mocking = e.mocking && {
		...e.mocking,
		status: e.mocking?.status ?? 200
	}, t.demoModeHandler = e.demoModeHandler, t;
};
//#endregion
export { i as n, r, a as t };

//# sourceMappingURL=createEndpoints-BYEC3FIA.js.map